<div class="document-container">
    <div class="d-flex flex-row align-items-center">
        <div class="file-icon-container">
            <mat-icon class="file-icon">insert_drive_file</mat-icon>
        </div>
        <div class="d-flex flex-column">
            <div>
                {{ fileName }}
            </div>
            <div class="text-muted">
                {{ description }}
            </div>
        </div>
    </div>
</div>